
import * as vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      forms: [],
      formId: 0,
      formData: null,
      pageData: null,
      formFiles: [],
      selectedFiles: [],
      showSuccessMsg: false,
      activeTooltip: null,
      fieldOptionsOpen: false,
      selectedOption: null,
      disableParkingInput: false,
      nonexistentAddress: false,
    };
  },
  watch: {
    $isInEditMode(v) {
      this.getAllForms();
    },
  },
  mounted() {
    this.getPageData();

    if (this.$isInEditMode) {
      this.getAllForms();
    }

    setTimeout(() => {
      this.$watch(
        () => {
          return this.$refs.accommodation?.form["att_parkirno-mjesto_yesNo"];
        },
        (val) => {
          if (val === this.$t("text.no")) {
            this.disableParkingInput = true;

            if (
              this.$refs.accommodation &&
              this.$refs.accommodation.form &&
              this.formData
            ) {
              this.$refs.accommodation.form[
                "att_broj-parkirnih-mjesta_numberField"
              ] = 0;

              this.formData["att_broj-parkirnih-mjesta_numberField"] = 0;
            }
          } else {
            this.disableParkingInput = false;
          }
        }
      );
    }, 500);
  },
  methods: {
    toggleFieldOptions() {
      this.fieldOptionsOpen = !this.fieldOptionsOpen;
    },

    closeFieldOptions() {
      this.fieldOptionsOpen = false;
    },

    selectOption(optionName, form, field) {
      this.selectedOption = optionName;

      form[field.key] = [`${this.selectedOption}`];
    },

    getPageData() {
      if (
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.pageData
      ) {
        this.pageData = this.$parent.$parent.pageData;

        if (
          this.pageData &&
          this.pageData.components &&
          this.pageData.components.length
        ) {
          this.pageData.components.forEach((data) => {
            if (data && data.linkMeta && data.linkMeta.formId) {
              this.formId = parseInt(
                data.linkMeta.formId.replace(/(<([^>]+)>)/gi, "")
              );
              this.getForm();
            }
          });
        }
      }
    },

    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getForm() {
      try {
        const data = await this.$axios.get(
          "/api/v1/cms/form/get/" + this.formId
        );
        if (data && data.data && data.data.data) {
          this.formData = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    setFormInputs(form, field, options, currentOption) {
      if (!form) return;

      if (this.formData[field.key]) {
        if (
          field.type !== "file" &&
          field.type !== "checkbox" &&
          field.type !== "multiselect" &&
          field.type !== "radio"
        ) {
          form[field.key] = this.formData[field.key];
        }
      } else {
        if (field.type === "checkbox" || field.type === "multiselect") {
          const selected = JSON.parse(form[field.key]) ?? [];
          let values;

          if (selected.includes(currentOption.name)) {
            values = selected.filter((option) => {
              return option !== currentOption.name;
            });
            if (values.length === 0) {
              values = null;
            }
          } else {
            values = [...selected, currentOption.name];
          }

          form[field.key] = values ? JSON.stringify(values) : null;
        } else if (field.type === "radio") {
          form[field.key] = currentOption.name;
        } else {
          form[field.key] = null;
        }
      }

      // set Attribute set id
      const attributeSetField = this.formData.fields.filter(
        (field) => field.key === "attributeSetId"
      );

      if (
        attributeSetField &&
        attributeSetField[0] &&
        form[attributeSetField[0].key] === null
      ) {
        form[attributeSetField[0].key] = this.$config.attributeSetId;
      }
    },

    setToNull(formField, key) {
      this.$toast.error(this.$t("toast.minPhotos"));

      formField = null;

      if (this.$refs.accommodation && this.$refs.accommodation.form[key]) {
        this.$refs.accommodation.form[key] = null;
      }
    },

    returnAllowedExts(file) {
      if (!file) return;

      let allowedExts;
      let index;

      if (file.validation && file.validation.length) {
        if (file.validation.length > 1) {
          index = 1;
        } else {
          index = 0;
        }

        if (typeof file.validation[index] === "string") {
          allowedExts = file.validation[index].replace("allowedExts:", "");

          allowedExts = allowedExts.replace("[", "");
          allowedExts = allowedExts.replace("]", "");
          allowedExts = allowedExts
            .split(" ")
            .map((s) => "." + s)
            .join(" ");
        }
      }

      return allowedExts;
    },

    setFiles(form, field, event) {
      this.selectedFiles = [];

      if (event && event.length && event.length > 4) {
        event.forEach((e) => {
          if (this.validateFilesSize(e)) {
            this.selectedFiles.push(e);
          }
        });

        form[field.key] = event;
      } else {
        form[field.key] = null;
      }
    },

    fileUpload(event, form, field) {
      this.selectedFiles = [];
      form[field.key] = null;

      if (!event.target.files) return;
      const files = Array.from(event.target.files);

      if (files && files.length && this.validateFilesSize(files, form, field)) {
        files.forEach((file) => {
          this.selectedFiles.push(file.name);
        });
      }
    },

    validateFilesSize(files) {
      if (!files) return;

      var filesSize = 0;

      if (files && files.length) {
        files.forEach((file) => {
          filesSize += file.size;
        });
      }

      if (filesSize / 1024 ** 2 > 10) {
        this.$toast.error(this.$t("toast.fileTooBig"));
        form[field.key] = null;
        return false;
      } else return true;
    },

    deleteFile(file, form, field) {
      if (!file) return;

      form[field.key] = form[field.key].filter(function (item) {
        return item !== file.media;
      });

      this.selectedFiles = this.selectedFiles.filter(function (item) {
        return item !== file;
      });
    },

    returnIfTextarea(validations) {
      if (!validations || !validations.length) return;

      var textarea = false;

      validations.forEach((validation) => {
        if (validation.includes("max")) {
          const result = validation.replace("max:", "");
          if (Number(result) > 200) {
            textarea = true;
          }
        }
      });

      return textarea;
    },

    async getCoordinates(form, submit) {
      if (!form) return;

      const body = {
        address: `${form["att_adresa-objekta_textField"]},${form["category"]}, ${form["att_zupanija_multipleSelect"]}`,
      };

      try {
        const data = await this.$axios.post(
          "/api/v1/settings/external/findLocationCms",
          body
        );
        if (
          data &&
          data.data &&
          data.data.data &&
          data.data.data.results &&
          data.data.data.results.length
        ) {
          if (
            data.data.data.results[0].geometry &&
            data.data.data.results[0].geometry.location_type &&
            data.data.data.results[0].geometry.location_type === "ROOFTOP"
          ) {
            form["att_latitude_textField"] =
              data.data.data.results[0].geometry.location.lat;
            form["att_longitude_textField"] =
              data.data.data.results[0].geometry.location.lng;

            this.nonexistentAddress = false;

            submit();
          } else this.nonexistentAddress = true;
        } else this.nonexistentAddress = true;
      } catch (e) {
        console.log(e);
      }
    },

    submitForm(form, submit) {
      if (`${form["attributeSetId"]}` === "undefined") {
        submit();
      } else {
        this.getCoordinates(form, submit);
      }
    },
  },
};
